import React from 'react';
import { Star } from 'lucide-react';
import { translations } from '../utils/translations';
interface SocialProofProps {
  lang: string;
}
export function SocialProof({
  lang
}: SocialProofProps) {
  const t = translations[lang as keyof typeof translations] || translations.en;
  const reviews = [{
    id: 1,
    text: "They saved me at 2AM on I-85. Fastest tow I've ever called.",
    author: 'Maria G.',
    location: 'Duluth GA'
  }, {
    id: 2,
    text: 'Rented an SUV last minute for a family trip. Super clean and affordable.',
    author: 'Carlos M.',
    location: 'Braselton GA'
  }, {
    id: 3,
    text: 'Best towing service in Georgia. Honest price, no games.',
    author: 'James R.',
    location: 'Atlanta GA'
  }];
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-94">
      <div className="max-w-6xl mx-auto" data-id="element-95">
        <div className="text-center mb-12" data-id="element-96">
          <h2 className="text-4xl md:text-5xl text-white mb-4" data-id="element-97">
            {t.socialTitle}
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto" data-id="element-98"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-99">
          {reviews.map(review => <div key={review.id} className="bg-brand-black p-8 rounded-lg border border-gray-800 relative" data-id="element-100">
              <div className="flex text-brand-red mb-4" data-id="element-101">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-102" />)}
              </div>
              <p className="text-gray-300 font-body text-lg mb-6 italic" data-id="element-103">
                "{review.text}"
              </p>
              <div className="mt-auto" data-id="element-104">
                <p className="text-white font-bold font-body" data-id="element-105">
                  {review.author}
                </p>
                <p className="text-gray-500 font-body text-sm" data-id="element-106">
                  {review.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}